import { MeasureComponent } from "@component/MeasureComponent";
import type { PureMeasureComponentProps } from "@component/PureMeasureComponent";
import { Chart } from "@landing/deviza/components/Chart";
import type { Currency } from "@landing/deviza/types";
import { GoogleAnalytics4 } from "@utils/google-analytics-4";
import type { ReactNode } from "react";
import React from "react";
import VisibilitySensor from "react-visibility-sensor";

interface Props extends PureMeasureComponentProps {
	currency: Currency;
}

/**
 * @Shortcode
 *
 * @title "Deviza grafikon"
 * @shortcode "article_foreign_currency_chart"
 * @type "widget"
 * @propsList "[{"currency":"eur"},{"currency":"usd"}]"
 */
export class ArticleForeignCurrencyEmbed extends MeasureComponent<Props> {
	protected productTypes = "";
	protected readonly componentType: string = "widget";

	public render(): ReactNode {
		const { currency } = this.props;
		const { wasVisible } = this.state;

		return (
			<VisibilitySensor
				{...GoogleAnalytics4.getVisibilitySensorProps()}
				active={!wasVisible}
				onChange={this.onVisibilityChange}
			>
				<div className="bg-trianglify-purple text-white p-3">
					<Chart currency={currency} isEmbed />
				</div>
			</VisibilitySensor>
		);
	}

	protected getComponentName(): string {
		return "ArticleForeignCurrencyEmbed";
	}
}

export default ArticleForeignCurrencyEmbed;
